import _ from 'lodash';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Row } from 'react-bootstrap';
import { fetchFaultTypesOverTime } from '../../../Service/APIService';
import Auth from '../../../shared/Auth';
import CustomWidget from '../../Custom/CustomWidget';
import ChartFaultOverLocation from './ChartFaultOverLocation';
import ChartFaultOverTime from './ChartFaultOverTime';

const ChartFaultsTimeAndLocation = ({ type, id }) => {
  const [isLoading, setLoading] = useState(true);
  const [data, setData] = useState({
    days: [],
    series: [],
    seriesLoc: [],
    locations: [],
  });

  const fetchDurationAndTimes = (selectedObj) => {
    const { length } = selectedObj;
    return length === 0
      ? [0, 0]
      : [
          _.sumBy(selectedObj, 'NoOfTimes'),
          _.sumBy(selectedObj, (item) => Number(item.Duration)),
        ];
  };

  const drawChart = async (_data) => {
    const obj = {
      day: [],
      types: [],
      durations: [],
      typesLoc: [],
      locations: [],
      tmpLocArr: [],
    };

    const filteredRecords = _.sortBy(_.uniq(_.map(_data, 'Dt'), true));
    const distinctFaultTypes = _.uniq(_.map(_data, 'FaultType'));
    const distinctLocations = _.uniq(_.map(_data, 'assetName'));
    const len = distinctFaultTypes.length;
    const tempArr = _.times(len, _.constant([]));
    const tmpDurationArr = _.times(len, _.constant([]));

    const tempArrLoc = _.times(len, _.constant([]));
    const tmpLocArr = _.times(distinctLocations.length, _.constant([]));

    _.map(filteredRecords, (recrd) => {
      obj.day.push(moment(recrd).format('DD/MM'));
      _.map(distinctFaultTypes, (chitem, index) => {
        const selectedObj = _.filter(_data, { Dt: recrd, FaultType: chitem });
        const durations_noOfTimes = fetchDurationAndTimes(selectedObj);

        tempArr[index] = [...tempArr[index], durations_noOfTimes[0]];
        tmpDurationArr[index] = [
          ...tmpDurationArr[index],
          durations_noOfTimes[1],
        ];
      });
    });

    _.map(distinctLocations, (recrd) => {
      obj.locations.push(recrd);
      _.map(distinctFaultTypes, (chitem, index) => {
        const selectedObj = _.filter(_data, {
          assetName: recrd,
          FaultType: chitem,
        });
        const durations_noOfTimes = fetchDurationAndTimes(selectedObj);
        tempArrLoc[index] = [
          ...(tempArrLoc[index] || []),
          durations_noOfTimes[0],
        ];
        tmpLocArr[index] = [
          ...(tmpLocArr[index] || []),
          durations_noOfTimes[1],
        ];
      });
    });

    obj.typesLoc.push(tempArrLoc);
    obj.tmpLocArr.push(tmpLocArr);

    obj.types.push(tempArr);
    obj.durations.push(tmpDurationArr);

    const seriesLoc = _.flatten(
      _.map(obj.typesLoc[0], (item, index) => [
        {
          name: distinctFaultTypes[index],
          data: item,
          type: 'column',
          marker: { enabled: false, symbol: 'circle', radius: 2 },
          lineWidth: 3,
          yAxis: 1,
          legendIndex: 1,
        },
        {
          name: `${distinctFaultTypes[index]}_duration`,
          type: 'line',
          marker: { enabled: false, symbol: 'circle', radius: 2 },
          lineWidth: 3,
          data: obj.tmpLocArr[0][index],
          legendIndex: 0,
          zIndex: 2,
        },
      ])
    );

    const series = _.flatten(
      _.map(obj.types[0], (item, index) => [
        {
          name: distinctFaultTypes[index],
          data: item,
          type: 'column',
          marker: { enabled: false, symbol: 'circle', radius: 2 },
          lineWidth: 3,
          yAxis: 1,
          legendIndex: 1,
        },
        {
          name: `${distinctFaultTypes[index]}_duration`,
          type: 'line',
          marker: { enabled: false, symbol: 'circle', radius: 2 },
          lineWidth: 3,
          data: obj.durations[0][index],
          legendIndex: 0,
          zIndex: 2,
        },
      ])
    );

    setData({
      days: obj.day,
      series,
      seriesLoc,
      locations: obj.locations,
    });
    setLoading(false);
  };

  const bindData = async () => {
    setLoading(true);
    fetchFaultTypesOverTime(type, id).then((response) => {
      const { statusCode, result } = response.data;
      drawChart(statusCode === 200 ? result : []);
    });
  };

  useEffect(() => {
    async function fetchData() {
      const checkToken = await Auth();
      if (checkToken) {
        bindData();
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type, id]);

  return (
    <>
      <Row>
        <CustomWidget
          size={12}
          id={'chrtFaultSummaryOverTime'}
          title={'Fault summary over Time'}
        >
          <ChartFaultOverTime
            isLoading={isLoading}
            series={data.series}
            days={data.days}
          />
        </CustomWidget>
      </Row>
      <Row>
        <CustomWidget
          size={12}
          id={'chrtFaultSummaryOverLocation'}
          title={'Fault summary over location'}
        >
          <ChartFaultOverLocation
            isLoading={isLoading}
            series={data.seriesLoc}
            locations={data.locations}
          />
        </CustomWidget>
      </Row>
    </>
  );
};

export default ChartFaultsTimeAndLocation;
